@if (embedded) {
    <button class="mindmap-list__close-button"
            (click)="close()"
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
        <mat-icon svgIcon="cross"></mat-icon>
    </button>
}

<app-banner-info [rolesCanShowBanner]="rolesCanShowBannerInfo"
                    situation="mindmap-list">
</app-banner-info>

<mat-toolbar class="mindmap-list__filters filters">
    <mat-toolbar-row class="mindmap-list__filter-row">
        <app-search-filters (launchSearch)="refreshNotes($event).subscribe()"
                            [countEntities]="paginator?.count"
                            [customFieldName]="[{field: 'metadatas_title', value: 'generic.title'}]"
                            [fields]="filters"
                            [overrideEndpointFilterName]="[{originalFilterName: 'lessons', targetFilterName: 'associated_node'}]">
        </app-search-filters>
    </mat-toolbar-row>
</mat-toolbar>

@if (isLoadingDone) {
    <div class="mindmap-list__cards">
        <button class="mindmap-list__add-button"
                (click)="createNote($event)"
                (keyup.enter)="createNote($event)">
            <mat-icon svgIcon="add"></mat-icon>
            <span>{{ 'mindmap.add_mindmap' | translate }}</span>
        </button>
        @for (mindmap of mindmaps; track $index) {
            <app-mindmap-card (actionTriggered)="onActionTriggered($event)"
                                (hasChanged)="onMindmapChanged(mindmap)"
                                [embedded]="embedded"
                                [forceAssociationOnSave]="forceAssociationOnSave"
                                [mindmapBasicSearchEntity]="mindmap">
            </app-mindmap-card>
        }
    </div>
    <mat-paginator (page)="onPaginateChange($event)"
                    [length]="paginator.count"
                    [pageIndex]="paginator.page -1"
                    [pageSize]="mindmapListRange">
    </mat-paginator>
} @else {
    <mat-spinner></mat-spinner>
}
